import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M696.208213,156.026053 C902.928497,156.026053 1071.08956,324.187114 1071.08956,530.907398 L1071.08956,530.907398 L1071.08956,638.016354 C1071.08956,751.444738 1019.35593,852.020048 939.452651,920.891106 C997.505705,927.853188 1055.34454,936.636123 1112.64783,948.632326 C1274.70368,982.800083 1392.41643,1137.35831 1392.41643,1316.23026 L1392.41643,1316.23026 L1392.41643,1521.98657 L1370.5662,1538.05291 C1253.17478,1624.27562 1013.78627,1763.83859 695.45845,1763.83859 C678.535235,1763.83859 661.504911,1763.41015 644.260369,1762.66039 C363.742014,1749.48599 150.916519,1633.27277 21.743118,1537.9458 L21.743118,1537.9458 L0,1521.87946 L0,1316.12315 C0,1137.2512 117.819851,982.692974 279.98281,948.525217 C336.964775,936.636123 394.589393,927.424753 452.428229,920.355561 C372.739166,851.591612 321.326867,751.23052 321.326867,638.016354 L321.326867,638.016354 L321.326867,530.907398 C321.326867,324.187114 489.487928,156.026053 696.208213,156.026053 Z M607.307779,477.35292 C512.409244,477.35292 493.772286,547.295069 428.435823,573.750981 L428.435823,573.750981 L428.435823,638.016354 C428.435823,785.612495 548.612071,905.788744 696.208213,905.788744 C843.804354,905.788744 963.980602,785.612495 963.980602,638.016354 L963.980602,638.016354 L963.980602,530.907398 C963.980602,528.443892 963.337948,526.087495 963.230839,523.51688 C962.594612,524.095269 961.959627,524.6749 961.325586,525.255492 L959.425993,526.999872 C959.109766,527.290989 958.793701,527.582276 958.477759,527.873698 L956.583293,529.623569 C955.952099,530.207211 955.321102,530.791113 954.690001,531.374992 L952.79609,533.126282 C952.480287,533.418058 952.164383,533.709759 951.848341,534.001349 L949.950137,535.749277 C922.710236,560.775759 893.89707,584.461876 839.734213,584.461876 C722.985451,584.461876 722.985451,477.35292 607.307779,477.35292 Z M1839.91504,156 L1920,236.084956 L1719.73097,436.353982 L1920,636.623009 L1839.91504,716.707965 L1639.64602,516.438938 L1439.49027,716.707965 L1359.29204,636.623009 L1559.56106,436.353982 L1359.29204,236.084956 L1439.49027,156 L1639.64602,356.269027 L1839.91504,156 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconDeactivateUserSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconDeactivateUserSolid, _Component);

  var _super = _createSuper(IconDeactivateUserSolid);

  function IconDeactivateUserSolid() {
    _classCallCheck(this, IconDeactivateUserSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconDeactivateUserSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconDeactivateUser",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconDeactivateUserSolid.displayName = "IconDeactivateUserSolid";
  return IconDeactivateUserSolid;
}(Component);

IconDeactivateUserSolid.glyphName = 'deactivate-user';
IconDeactivateUserSolid.variant = 'Solid';
IconDeactivateUserSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconDeactivateUserSolid;
export { IconDeactivateUserSolid };